import { createContext, useContext } from 'react';

interface CarouselCardPosition {
  label: string;
}

export const CarouselCardContext = createContext<CarouselCardPosition | null>(
  null
);

export function useCarouselCardPosition(): string | undefined {
  return useContext(CarouselCardContext)?.label;
}
